exports.ImageUploadModule = require('./lib/image-upload.module').ImageUploadModule;



//////////////////
// WEBPACK FOOTER
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/~/angular2-image-upload/index.js
// module id = ../../../../angular2-image-upload/index.js
// module chunks = 3